/* eslint-disable react/jsx-props-no-spreading */

import { Box } from 'components/layout/box'
import { SpaceProps } from 'styled-system'

export type DialogContentProps = SpaceProps

const DialogContent: React.FC<DialogContentProps> = ({
  children,
  ...other
}) => (
  <Box
    fontFamily="default"
    fontSize="body2"
    lineHeight="body2"
    letterSpacing="body2"
    color="texts.mediumEmphasis"
    height="100%"
    css={{ position: 'relative' }}
    {...other}
  >
    {children}
  </Box>
)

export default DialogContent
